import React, { useState } from 'react'
import LoginRenderer from './renderer'
import { useAuth } from '../../../auth/useAuth'
import { cognitoSignOut, forgotPassword } from '../../../clients/userPool'

const CognitoLoginRenderer = (props) => {
  const [initialized, setInitialized] = useState(false)

  if (!initialized) {
    cognitoSignOut()
    setInitialized(true)
  }

  const auth = useAuth()

  const newSubmit = () => {
    if (!props.password) {
      props.setShowErrorMessage(true)
      props.setError('Please enter your username and password.')
      return
    }

    props.cognitoLoginAttempt({ status: 'attempting' })

    const fail = (err) => {
      props.setError('')
      props.cognitoLoginError(err)
    }

    auth.signIn({ username: props.username.toLowerCase(), password: props.password, fail, props })
  }

  const cognitoForgotPasswordSubmit = (email, setStatus) => {
    if (!email) {
      setStatus('noEmail')
    } else {
      setStatus('attempting')
      forgotPassword(email.toLowerCase(),
        () => {
          setStatus('attempt')
          props.forgotPasswordSuccess()
          auth.resetPassword(email.toLowerCase())
        },
        (error) => {
          switch (error.code) {
            case 'NotAuthorizedException':
              cognitoResendTemporalPassword(email)
              break
            case 'UserNotFoundException':
              setStatus('emailNotFound')
              break
            case 'LimitExceededException':
              setStatus('limitExceeded')
              break
            default:
              setStatus('attempt')
          }
          props.forgotPasswordFailure()
        })
    }
  }

  const cognitoResendTemporalPassword = (email, setStatus) => {
    auth.resendTemporalPassword(email.toLowerCase(),
      () => {
        setStatus('attempt')
        props.forgotPasswordFailure()
      })
  }

  return (
    <LoginRenderer {...{ ...props, newSubmit, cognitoForgotPasswordSubmit, cognitoResendTemporalPassword }} />
  )
}

export default CognitoLoginRenderer
